import { Injectable } from '@angular/core';

import { InfillsKindsUtilsService } from './kinds/tools/infills-kinds-utils.service';
import { Infills } from './model/infills';
import { InfillClippedByFourPointsService } from './kinds/infills-clipped-by-four-points.service';
import { StageService } from '../../stage.service';
import { SizeHelperService } from '../../size-helper.service';
import { ProductsService } from '../../products.service';
import { DataForDisplayingMenuItemsService } from '../../data-for-displaying-menu-items.service';
import { ConstantsService } from '../../constants.service';
import { ModelLoaderService } from '../../model-loader.service';
import { HelperLinesService } from '../../helper-lines.service';
import { RailingColorsService } from '../services/railing-colors.service';
import { DistanceHelperService } from '../../distance-helper.service';
import { InfillTypes, isPanelInfill } from './model/infill-types';
import { VerticalPicketService } from '../../vertical-picket.service';

declare var THREE: any;

@Injectable()
export class InfillsForStairsAndLandingService {
  currentParams: any;
  intermediatePost: any;

  glass: any;
  glassClear: any;
  glassSmoke: any;
  glassDark: any;

  laserCutAgama: any;
  laserCutBound: any;
  laserCutCubist: any;
  laserCutPisces: any;
  laserCutRhythm: any;
  laserCutSeagrass: any;
  laserCutSverra: any;
  laserCutTrillium: any;
  laserCutPulse: any;

  steelMeshAllure: any;
  steelMeshDazzle: any;
  steelMeshMetropolitan: any;
  steelMeshHorizon: any;

  verticalPicket: any;
  horizontalCableVerticalPicket: any;
  verticalCable: any;
  singleHorizontalCable: any;
  stairGlass: any;
  horizontalCable: any;
  handrail: any;
  baserail: any;
  cornerPost: any;

  constructor(
    private stage: StageService,
    private sizeHelper: SizeHelperService,
    private productSrvc: ProductsService,
    private dataForMenu: DataForDisplayingMenuItemsService,
    private constants: ConstantsService,
    private modelLoaderService: ModelLoaderService,
    private helperLinesService: HelperLinesService,
    private railingColorsService: RailingColorsService,
    private distanceHelper: DistanceHelperService,
    private infillsUtilsService: InfillsKindsUtilsService,
    private infillClippedByFourPointsService: InfillClippedByFourPointsService,
    private verticalPicketService: VerticalPicketService
  ) {}

  addInfillForStairs(pos1, pos2, infills, railingComponent, isForTiers: boolean = false) {
    this.updateCurrentParams();
    this.intermediatePost = railingComponent.intermediatePost;
    this.cornerPost = railingComponent.cornerPost;

    this.glass = railingComponent.glass;
    // glass / laser-cut / steel-mesh panel models are keyed by their InfillTypes name
    Object.keys(InfillTypes).forEach(key => (this[key] = railingComponent[key]));

    this.verticalPicket = railingComponent.verticalPicket;
    this.horizontalCableVerticalPicket = railingComponent.horizontalCableVerticalPicket;
    this.verticalCable = railingComponent.verticalCableForStairs;
    this.singleHorizontalCable = railingComponent.singleHorizontalCable;
    this.horizontalCable = railingComponent.horizontalCableForStairs;
    this.stairGlass = railingComponent.stairGlass;
    this.handrail = railingComponent.handrailForStairs || railingComponent.handrail;
    this.baserail = railingComponent.baserail;
    // let offset = new THREE.Vector3(pos2.x - pos1.x, 0, pos2.z - pos1.z);
    // let offsetLength = Math.abs(this.sizeHelper.INCHToCM(2.5) + +this.intermediatePost.userData.entity.offset);
    // if ( +this.intermediatePost.userData.entity.offset > 0) {
    //   offset.negate();
    // }
    // offset.setLength(offsetLength);
    // pos1.add(offset);

    switch (this.currentParams.infill) {
      case 'verticalCable':
        {
          this.setPositionsForVerticalCablesForStairs(pos1, pos2, infills);
        }
        break;
      case 'horizontalCableBaserail':
        {
          this.addHorizontalCablesForStairs(pos1, pos2, infills, isForTiers);
        }
        break;
      case 'horizontalCable':
        {
          this.addHorizontalCablesForStairs(pos1, pos2, infills, isForTiers);
        }
        break;
      default:
        // glass / laser-cut / steel-mesh panel infills (see InfillTypes)
        if (isPanelInfill(this.currentParams.infill)) {
          this.addAndCutInfillForStairs(pos1, pos2, infills, this.currentParams.infill);
        }
        break;
      case 'verticalPicket':
        {
          this.setPositionsForVerticalPicketForStairs(pos1, pos2, infills);
        }
        break;
    }

    // offset.negate();
    // pos1.add(offset);
  }

  setPositionsForVerticalCablesForStairs(pos1, pos2, infills) {
    const length = pos1.distanceTo(pos2) - 10;
    let count, offset;
    for (let i = 1; length / i > 7.62; i++) {
      if (length / i < 10.16) {
        count = i - 1;
        offset = length / i;
      }
    }

    if (
      length + 10 < this.sizeHelper.INCHToCM(42) &&
      length + 10 > this.sizeHelper.INCHToCM(21) &&
      count % 2 === 0
    ) {
      count -= 1;
      offset = length / (count + 1);
    }

    let firstPicket = null,
      secondPicket = null;

    if (length + 10 > this.sizeHelper.INCHToCM(42)) {
      switch ((count + 1) % 3) {
        case 0:
          {
            firstPicket = (count + 1) / 3 - 1;
          }
          break;
        case 1:
          {
            firstPicket = Math.floor((count + 1) / 3) - 1;
          }
          break;
        case 2: {
          firstPicket = Math.ceil((count + 1) / 3) - 1;
        }
      }
      secondPicket = count - firstPicket - 1;
    }
    if (
      pos1.distanceTo(pos2) < this.sizeHelper.INCHToCM(42) &&
      pos1.distanceTo(pos2) > this.sizeHelper.INCHToCM(21)
    ) {
      this.addSingleVerticalPicketForVerticalCables(pos1, pos2, infills);
    }
    const position = pos1.clone();
    const direction = new THREE.Vector3(pos2.x - pos1.x, pos2.y - pos1.y, pos2.z - pos1.z);
    direction.setLength(5);
    position.add(direction);
    direction.setLength(offset);
    for (let i = 0; i < count; i++) {
      position.add(direction);
      let pos = position.clone();
      if (i === firstPicket || i === secondPicket) {
        this.addVerticalPicketForStairs(pos, infills);
      } else {
        this.addVerticalCableForStairs(pos, infills);
      }
    }
  }

  addVerticalCableForStairs(position, infills) {
    const obj = this.verticalCable.clone();
    obj.children.forEach(ch => (ch.castShadow = true));
    obj.visible = true;

    const height =
      this.verticalCable.userData.entity.placementHeight +
      this.verticalCable.userData.entity.height / 2 +
      position.y +
      5;

    // obj.scale.x = 0.1;
    // obj.scale.y = 1.1;
    obj.position.set(position.x, height, position.z);

    this.stage.add(obj);
    infills.push(obj);
    // });
  }

  addHorizontalCablesForStairs(pos1, pos2, infills, isForTiers: boolean) {
    let SingleHorizontalCable = this.singleHorizontalCable.clone();
    // isForTiers is a flag to check if
    // it's related to tiers infill,
    // some settings are slightly different
    this.addSingleVerticalPicket(pos1, pos2, infills);

    if (isForTiers) {
      const height = this.horizontalCable.userData.entity.height;
      let count, gap;
      // using a singleHorizontalCable
      // which is different than a horizontalCable
      // than includes all cables in one model
      for (let i = 1; height / i > 7.62; i++) {
        if (height / i < 10.16) {
          count = i - 1;
          gap = height / i;
        }
      }

      for (let i = 0; i < count; i++) {
        let obj = SingleHorizontalCable.clone();
        obj.children.forEach(ch => (ch.castShadow = true));
        obj.position.set((pos1.x + pos2.x) / 2, (pos1.y + pos2.y) / 2, (pos1.z + pos2.z) / 2);

        let direction = new THREE.Vector3(pos2.x - pos1.x, 0, pos2.z - pos1.z);
        direction = new THREE.Vector3(-direction.z, 0, direction.x);
        direction.setLength(1);

        // this.horizontalCable.userData.entity.placementHeight + this.horizontalCable.userData.entity.height / 2 + this.dHeight;
        const horizontalDistance = Math.pow(
          Math.pow(pos1.x - pos2.x, 2) + Math.pow(pos1.z - pos2.z, 2),
          1 / 2
        );
        obj.position.y += this.horizontalCable.userData.entity.placementHeight + gap * i;
        obj.scale.x = (pos1.distanceTo(pos2) + (horizontalDistance > 5 ? 40 : 15)) / 150;
        // rotate infill according to slope
        // of stairs or tires
        obj.rotation.z -= Math.atan((pos1.y - pos2.y) / horizontalDistance);
        if (horizontalDistance < 5) {
          if (pos1.y < pos2.y) {
            obj.rotation.z = 0.85;
          } else {
            obj.rotation.z = -0.85;
          }
        }

        for (let j = 0; j < 6; j++) {
          const worldDir = obj.getWorldDirection(new THREE.Vector3());
          // worldDir = new THREE.Vector3(worldDir.x, worldDir.z, worldDir.y);
          if (
            !(
              direction.x - worldDir.x > -0.05 &&
              direction.x - worldDir.x < 0.05 &&
              direction.z - worldDir.z > -0.05 &&
              direction.z - worldDir.z < 0.05
            )
          ) {
            obj.rotation.y += worldDir.angleTo(direction);
          }
        }

        this.stage.add(obj);

        infills.push(obj);
      }
    } else {
      let countOfCables = 8;
      let risingForBottomCable = 1;
      if (this.currentParams.infill === 'horizontalCable') {
        countOfCables = 9;
        risingForBottomCable = 0;
      }
      for (let i = 0; i < countOfCables; i++) {
        let obj = SingleHorizontalCable.clone();
        obj.children.forEach(ch => (ch.castShadow = true));
        obj.position.set((pos1.x + pos2.x) / 2, (pos1.y + pos2.y) / 2, (pos1.z + pos2.z) / 2);

        let direction = new THREE.Vector3(pos2.x - pos1.x, 0, pos2.z - pos1.z);
        direction = new THREE.Vector3(-direction.z, 0, direction.x);
        direction.setLength(1);

        const baserailHeight =
          (this.baserail
            ? this.baserail.userData.entity.placementHeight +
              this.baserail.userData.entity.height +
              6
            : 0) +
          (Math.min(
            this.handrail.userData.entity.width / 2 - 1.8,
            this.intermediatePost.userData.entity.length / 2
          ) *
            7) /
            9;

        const handrailHeight =
          this.handrail.userData.entity.placementHeight +
          (Math.min(
            this.handrail.userData.entity.width / 2 - 1.8,
            this.intermediatePost.userData.entity.length / 2
          ) *
            7) /
            9;

        obj.position.y +=
          baserailHeight + ((handrailHeight - baserailHeight) / 9) * (i + risingForBottomCable);
        obj.scale.x = pos1.distanceTo(pos2) / 150;
        obj.rotation.z = 0.6625;

        for (let j = 0; j < 6; j++) {
          const worldDir = obj.getWorldDirection(new THREE.Vector3());
          // worldDir = new THREE.Vector3(worldDir.x, worldDir.z, worldDir.y);
          if (
            !(
              direction.x - worldDir.x > -0.05 &&
              direction.x - worldDir.x < 0.05 &&
              direction.z - worldDir.z > -0.05 &&
              direction.z - worldDir.z < 0.05
            )
          ) {
            obj.rotation.y += worldDir.angleTo(direction);
          }
        }

        this.stage.add(obj);

        infills.push(obj);
      }
    }
  }

  addAndCutInfillForStairs(pos1, pos2, infills, infillType: string) {
    if (!this[infillType]) {
      console.warn(`Infill type '${infillType}' not found`);
      return;
    }

    this.infillClippedByFourPointsService.add(
      pos1,
      pos2,
      this[infillType],
      this.baserail,
      this.handrail,
      this.intermediatePost,
      infills,
      Infills.stairs,
      0.6625
    );
  }

  setPositionsForVerticalPicketForStairs(pos1, pos2, infills) {
    const length = pos1.distanceTo(pos2) - 10;
    for (var i = 1; length / i > 7.62; i++) {
      if (length / i < 10.16) {
        var count = i - 1;
        var offset = length / i;
      }
    }

    const position = pos1.clone();
    const direction = new THREE.Vector3(pos2.x - pos1.x, pos2.y - pos1.y, pos2.z - pos1.z);
    direction.setLength(5);
    position.add(direction);
    direction.setLength(offset);
    for (var i = 0; i < count; i++) {
      position.add(direction);
      const pos = position.clone();
      this.addVerticalPicketForStairs(pos, infills);
    }
  }

  addVerticalPicketForStairs(position, infills) {
    const obj = this.verticalPicket.clone();
    obj.children.forEach(ch => (ch.castShadow = true));
    obj.visible = true;
    obj.scale.y = 0.96;

    const height =
      this.verticalPicket.userData.entity.placementHeight +
      this.verticalPicket.userData.entity.height / 2 +
      position.y +
      5;

    // obj.scale.x = 0.1;
    // obj.scale.y = 1.1;
    obj.position.set(position.x, height, position.z);

    this.stage.add(obj);
    infills.push(obj);
    // });
  }

  addSingleVerticalPicketForVerticalCables(pos1, pos2, infills) {
    if (
      !(
        pos1.distanceTo(pos2) < this.sizeHelper.INCHToCM(42) &&
        pos1.distanceTo(pos2) > this.sizeHelper.INCHToCM(21)
      ) &&
      !pos1.isPicket
    )
      return;

    let rotationVector = new THREE.Vector3(pos1.x - pos2.x, 0, pos1.z - pos2.z);
    if (!pos1.isLeft) {
      rotationVector.negate();
    }
    let offsetVector = new THREE.Vector3(rotationVector.z, 0, -rotationVector.x);

    var norm = new THREE.Vector3(1, 0, 0);
    var angle = rotationVector.angleTo(norm);
    if (rotationVector.z > 0) {
      angle = -rotationVector.angleTo(norm);
    }

    const picket = this.verticalPicket.clone();
    picket.children.forEach(ch => (ch.castShadow = true));
    picket.visible = true;
    picket.rotation.y = angle;

    const isOdd =
      (pos1.distanceTo(pos2) * Math.cos(7 / 9)) % this.sizeHelper.INCHToCM(18) >
      this.sizeHelper.INCHToCM(7);

    let height = this.verticalPicket.userData.entity.height;
    let pickHeight: any;

    if (this.currentParams.infill === 'horizontalCable') {
      if (+this.intermediatePost.userData.entity.offset > 0) {
        let point = new THREE.Vector3(
          (pos1.x + pos2.x) / 2,
          (pos1.y + pos2.y) / 2 + this.handrail.userData.entity.placementHeight + 1,
          (pos1.z + pos2.z) / 2
        );

        height = this.distanceHelper.getDistanceToStair(point);

        picket.scale.y = height / this.verticalPicket.userData.entity.height;

        pickHeight =
          this.handrail.userData.entity.placementHeight - height / 2 + (pos1.y + pos2.y) / 2 + 1;
      } else {
        picket.scale.y = (this.handrail.userData.entity.placementHeight + 30) / height;
        height *= picket.scale.y;
        pickHeight =
          this.handrail.userData.entity.placementHeight - height / 2 + (pos1.y + pos2.y) / 2;
      }
    } else {
      pickHeight =
        this.handrail.userData.entity.placementHeight - height / 2 + (pos1.y + pos2.y) / 2 + 6;
      picket.scale.y = 0.96;
    }

    picket.position.set((pos1.x + pos2.x) / 2, pickHeight, (pos1.z + pos2.z) / 2);
    offsetVector.setLength(+picket.userData.entity.offset);
    picket.position.add(offsetVector);

    this.railingColorsService.setExistingColor(picket, 'Picket', 'Picket');
    this.stage.add(picket);
    infills.push(picket);
  }

  addSingleVerticalPicket(pos1, pos2, infills) {
    if (pos1.distanceTo(pos2) < this.sizeHelper.INCHToCM(36) && !pos1.isPicket) return;

    let rotationVector = new THREE.Vector3(pos1.x - pos2.x, 0, pos1.z - pos2.z);
    if (!pos1.isLeft) {
      rotationVector.negate();
    }
    let offsetVector = new THREE.Vector3(rotationVector.z, 0, -rotationVector.x);

    var norm = new THREE.Vector3(1, 0, 0);
    var angle = rotationVector.angleTo(norm);
    if (rotationVector.z > 0) {
      angle = -rotationVector.angleTo(norm);
    }

    const picket = this.horizontalCableVerticalPicket.clone();
    picket.children.forEach(ch => (ch.castShadow = true));
    picket.visible = true;
    picket.rotation.y = angle;

    const isOdd =
      (pos1.distanceTo(pos2) * Math.cos(7 / 9)) % this.sizeHelper.INCHToCM(18) >
      this.sizeHelper.INCHToCM(7);

    let height = this.horizontalCableVerticalPicket.userData.entity.height;
    let pickHeight: any;

    if (this.currentParams.infill === 'horizontalCable') {
      if (+this.intermediatePost.userData.entity.offset > 0) {
        let point = new THREE.Vector3(
          (pos1.x + pos2.x) / 2,
          (pos1.y + pos2.y) / 2 + this.handrail.userData.entity.placementHeight + 1,
          (pos1.z + pos2.z) / 2
        );

        height = this.distanceHelper.getDistanceToStair(point);

        picket.scale.y = height / this.horizontalCableVerticalPicket.userData.entity.height;

        pickHeight =
          this.handrail.userData.entity.placementHeight - height / 2 + (pos1.y + pos2.y) / 2 + 1;
      } else {
        picket.scale.y = (this.handrail.userData.entity.placementHeight + 30) / height;
        height *= picket.scale.y;
        pickHeight =
          this.handrail.userData.entity.placementHeight - height / 2 + (pos1.y + pos2.y) / 2;
      }
    } else {
      pickHeight =
        this.handrail.userData.entity.placementHeight - height / 2 + (pos1.y + pos2.y) / 2 + 6;
      picket.scale.y = 0.96;
    }

    picket.position.set((pos1.x + pos2.x) / 2, pickHeight, (pos1.z + pos2.z) / 2);
    offsetVector.setLength(+picket.userData.entity.offset);
    picket.position.add(offsetVector);

    this.verticalPicketService.setVerticalPicketColor(
      picket,
      this.currentParams.verticalPicketShapeType,
      this.currentParams.verticalPicketColorName,
      'Picket'
    );
    this.stage.add(picket);
    infills.push(picket);
  }

  /////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////

  addInfillForLanding(pos1, pos2, infills, railingComponent) {
    this.updateCurrentParams();

    // why it duplicates addInfillForStairs() method?
    this.intermediatePost = railingComponent.intermediatePost;
    this.cornerPost = railingComponent.cornerPost;

    this.glass = railingComponent.glass;
    // glass / laser-cut / steel-mesh panel models are keyed by their InfillTypes name
    Object.keys(InfillTypes).forEach(key => (this[key] = railingComponent[key]));

    this.verticalPicket = railingComponent.verticalPicket;
    this.verticalCable = railingComponent.verticalCableForStairs;
    this.horizontalCable = railingComponent.horizontalCableForStairs;
    this.handrail = this.handrail
      ? railingComponent.handrailForStairs
      : railingComponent.handrailForStairs;

    const firstToSecond = new THREE.Vector3(pos2.x - pos1.x, 0, pos2.z - pos1.z);
    const secondToFirst = new THREE.Vector3(pos1.x - pos2.x, 0, pos1.z - pos2.z);

    if (this.cornerPost.userData.entity.cornerType === 'Double') {
      firstToSecond.setLength(this.cornerPost.userData.entity.width / 2);
      secondToFirst.setLength(this.cornerPost.userData.entity.width / 2);

      if (!pos1.isTerminationPost && pos1.corner && !pos1.not90 && !pos1.Is45 && !pos1.Is135) {
        pos1.add(firstToSecond);
      }
      if (!pos2.isTerminationPost && pos2.corner && !pos2.not90 && !pos2.Is45 && !pos2.Is135) {
        pos2.add(secondToFirst);
      }
    }

    switch (this.currentParams.infill) {
      case 'verticalCable':
        {
          this.setPositionsForVerticalCablesForStairs(pos1, pos2, infills);
        }
        break;
      case 'horizontalCableBaserail':
        {
          this.addHorizontalCablesForLanding(pos1, pos2, infills);
        }
        break;
      case 'horizontalCable':
        {
          this.addHorizontalCablesForLanding(pos1, pos2, infills);
        }
        break;
      default:
        // glass / laser-cut / steel-mesh panel infills (see InfillTypes)
        if (isPanelInfill(this.currentParams.infill)) {
          this.addAndCutInfillForLanding(pos1, pos2, infills, this.currentParams.infill);
        }
        break;
      case 'verticalPicket':
        {
          this.setPositionsForVerticalPicketForLanding(pos1, pos2, infills);
        }
        break;
    }

    if (this.cornerPost.userData.entity.cornerType === 'Double') {
      if (!pos1.isTerminationPost && pos1.corner && !pos1.not90 && !pos1.Is45 && !pos1.Is135) {
        pos1.add(secondToFirst);
      }
      if (!pos2.isTerminationPost && pos2.corner && !pos2.not90 && !pos2.Is45 && !pos2.Is135) {
        pos2.add(firstToSecond);
      }
    }
  }

  addHorizontalCablesForLanding(pos1, pos2, infills) {
    const length = pos1.distanceTo(pos2); // - this.intermediatePost.userData.entity.width;

    this.addSingleVerticalPicket(pos1, pos2, infills);

    const height =
      this.horizontalCable.userData.entity.placementHeight +
      this.horizontalCable.userData.entity.height / 2 +
      pos1.y;

    const obj = this.horizontalCable.clone();
    obj.children.forEach(ch => (ch.castShadow = true));
    obj.visible = true;
    obj.scale.x = length / this.horizontalCable.userData.entity.length;
    obj.position.set((pos1.x + pos2.x) / 2, height, (pos1.z + pos2.z) / 2);
    const med = new THREE.Vector3(pos2.x - pos1.x, 0, pos2.z - pos1.z);
    med.setLength(1);
    const angle = Math.atan(med.z / med.x);
    // var norm = new THREE.Vector3(1, 0, 0);
    // med.angleTo(norm);

    obj.rotation.y = angle;
    const dir = obj.getWorldDirection(new THREE.Vector3());
    if (med.x * dir.z - med.z * dir.x != 0) {
      obj.rotation.y = Math.PI - obj.rotation.y;
    }

    this.stage.add(obj);
    infills.push(obj);
  }

  addAndCutInfillForLanding(pos1, pos2, infills, infillType: string) {
    // HelperLinesService.buildOneTestLineAndUpdate(pos1);
    // HelperLinesService.buildOneTestLineAndUpdate(pos2);
    if (!this[infillType]) {
      console.warn(`Infill type '${infillType}' not found`);
      return;
    }

    this.infillClippedByFourPointsService.add(
      pos1,
      pos2,
      this[infillType],
      this.baserail,
      this.handrail,
      this.intermediatePost,
      infills,
      Infills.stairsLanding
    );
  }

  setPositionsForVerticalPicketForLanding(pos1, pos2, infills) {
    const length = pos1.distanceTo(pos2) - 10;
    for (var i = 1; length / i > 7.62; i++) {
      if (length / i < 10.16) {
        var count = i - 1;
        var offset = length / i;
      }
    }

    const points: any = [];
    const position = pos1.clone();
    position.y -= 7;
    const direction = new THREE.Vector3(pos2.x - pos1.x, pos2.y - pos1.y, pos2.z - pos1.z);
    direction.setLength(5);
    position.add(direction);
    direction.setLength(offset);
    for (var i = 0; i < count; i++) {
      position.add(direction);
      var pos = position.clone();
      this.addVerticalPicketForStairs(pos, infills);
    }
  }

  addVerticalPicketForLanding(position, infills) {
    const obj = this.verticalPicket.clone();
    obj.visible = true;
    const pickHeight =
      this.verticalPicket.userData.entity.placementHeight +
      this.verticalPicket.userData.entity.height / 2 +
      position.y;
    // var height = this.verticalCable.userData.entity.placementHeight + this.verticalCable.userData.entity.height / 2 + this.dHeight;

    // obj.scale.x = 0.1;
    obj.position.set(position.x, pickHeight, position.z);

    // this.setExistingColor(obj, 'Picket', 'Pickets');

    this.stage.add(obj);
    infills.push(obj);
    // });
  }

  updateCurrentParams() {
    this.currentParams = this.dataForMenu.getCurrentParams();
  }
}



// WEBPACK FOOTER //
// ./src/app/services/railing/infills/infills-for-stairs-and-landing.service.ts